import React from 'react';

const BankManagement = () => {
    return (
        <div>
            BankManagement
            BankManagement
        </div>
    );
}

export default BankManagement;
